import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { educationService } from '@modules/staff/educationalDegree/services/educationService';
import { notifySuccess, notifyError } from '@config/tostifyConfig/tostifyConfig';
import useFormHook from '@shared/hooks/useFormHook';

export const useEducationForm = ({ degree, onClose, selectedData, fetchData }) => {
    const { t } = useTranslation();
    const { modalRef } = useFormHook({}, onClose);
    const [serverMessage, setServerMessage] = useState(null);

    const validationSchema = yup.object({
        education: yup.string()
            .required(t('validation.degreeLevel.education.notEmpty'))
            .min(1, t('validation.degreeLevel.education.size'))
            .max(255, t('validation.degreeLevel.education.size')),
        code: yup.string()
            .min(1, t('validation.degreeLevel.code.size'))
            .max(100, t('validation.degreeLevel.code.size'))
    });

    const { register, handleSubmit, formState: { errors }, setValue, watch } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: degree
            ? {
                id: degree.id,
                education: degree.education,
                code: degree.code,
                ordno: degree.ordno,
                active: Boolean(degree.active),
                degreeLevel: degree.degreeLevel,
                addCode: degree.addCode,
                addLevel: degree.addLevel
            }
            : {
                education: '',
                code: '',
                ordno: '',
                active: true,
                degreeLevel: '',
                addCode: '',
                addLevel: ''
            }
    });

    const isActiveChecked = watch('active', Boolean(degree?.active));

    const onSubmit = async (data) => {
        try {
            if (degree) {
                try {
                    await educationService.updateDegree(selectedData, data);
                    notifySuccess(t('education.table.updateSuccess'));
                } catch (error) {
                    setServerMessage(error?.response?.data?.code);
                    notifyError(t('education.table.updateError'));
                    return;
                }
            } else {
                try {
                    await educationService.createDegree(data);
                    notifySuccess(t('education.table.addSuccess'));
                } catch (error) {
                    const message = error?.response?.data?.code;
                    setServerMessage(message);
                    notifyError(message);
                    return;
                }
            }
            await fetchData();
            onClose();
        } catch (error) {
            console.error('Failed to submit degree', error);
        }
    };

    return {
        modalRef,
        register,
        handleSubmit,
        errors,
        setValue,
        isActiveChecked,
        serverMessage,
        onSubmit
    };
}; 